module.exports = __webpack_public_path__ + "img/Animales-MSU3.33bd3e90.png";